// extracted by mini-css-extract-plugin
export default {"section":"Header_section__bRUb-","container":"Header_container__AlJcb"};